import React from 'react'

import { Paper } from '@mui/material'

interface PaperPanelProps {
  children?: React.ReactNode
  centerText?: boolean
  elevation?: number
}

export const PaperPanel: React.FC<PaperPanelProps> = ({
  children,
  centerText,
  elevation = 3
}) => {
  return (
    <Paper
      elevation={elevation}
      style={{ padding: '20px', textAlign: centerText ? 'center' : 'left' }}
    >
      {children}
    </Paper>
  )
}
